import { render } from "./CallKeyPad.vue?vue&type=template&id=706c4048"
import script from "./CallKeyPad.vue?vue&type=script&lang=js"
export * from "./CallKeyPad.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__